import { deleteRubro, getRubrosPanel } from "../../services/RubrosServices";
import { RubrosContext } from "./RubrosContext"

export const RubrosState = ({ children }) => {

    const getRubrosPanelData = async (searchTerm,searchFilter, numpag, filas) => {
        let res = await getRubrosPanel(searchTerm, searchFilter,numpag, filas)
        return res
    }

    const deleteRubroData = async (body,searchTerm, searchFilter,numpag, filas) => {
        const res = await deleteRubro(body,searchTerm,searchFilter, numpag, filas)
        if (res) getRubrosPanelData()
        return res
    }

    return <RubrosContext.Provider value={{
        deleteRubroData,
        getRubrosPanelData,
    }} >
        {children}
    </RubrosContext.Provider>
}
